var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.176 13.824C31.368 11.016 27.696 9.6 24 9.6V24L13.824 34.176C19.44 39.792 28.56 39.792 34.2 34.176C39.816 28.56 39.816 19.44 34.176 13.824ZM24 0C10.752 0 0 10.752 0 24C0 37.248 10.752 48 24 48C37.248 48 48 37.248 48 24C48 10.752 37.248 0 24 0ZM24 43.2C13.392 43.2 4.8 34.608 4.8 24C4.8 13.392 13.392 4.8 24 4.8C34.608 4.8 43.2 13.392 43.2 24C43.2 34.608 34.608 43.2 24 43.2Z",
    fill: "#0091EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlue);
export default __webpack_public_path__ + "static/media/filterBlue.06604b809f887933c794d22a328cd175.svg";
export { ForwardRef as ReactComponent };